import AppStore from "@/store/AppStore"
import { ModuleName, TAPIPayload, TAdvancedFilterAPI } from "@/store/AppStore.types"
import { useGridApiRef } from "@mui/x-data-grid"
import { useRef } from "react"
import { useQueryClient } from "react-query"
import { calculateToFromFilter } from "./InfiniteTableExt"

const useInfiniteTable = (key: ModuleName) => {
  const prevRangeFilters: TAPIPayload = calculateToFromFilter(AppStore.counterCardFilter[key])
  const prevAdvFilters: TAdvancedFilterAPI = { ...AppStore.advancedFilterCache[key] }
  const filterRef = useRef<TAdvancedFilterAPI>({ ...prevRangeFilters, ...prevAdvFilters })
  const sortRef = useRef<{ field_name: string; orderBy: 'asc' | 'desc' }>({ field_name: '', orderBy: 'asc' })
  const isNextPage = useRef(true)
  const tableAPIRef = useGridApiRef()
  const queryClient = useQueryClient()

  const resetQuery = () => {
    isNextPage.current = true
    queryClient.setQueryData(key, (data: any) => ({
      pages: [],
    }))
    queryClient.fetchInfiniteQuery(key)
  }

  return { filterRef, sortRef, isNextPage, infiniteTableKey: key, tableAPIRef, queryClient, resetQuery }
}

export default useInfiniteTable